import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-folder",
  "use": "icon-folder-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-folder\">\r\n<path d=\"M4 17V7C4 6.44772 4.44772 6 5 6H10.5194C10.8232 6 11.1105 6.13809 11.3002 6.37531L12.6998 8.1247C12.8895 8.36191 13.1768 8.5 13.4806 8.5H16H19C19.5523 8.5 20 8.94772 20 9.5V17C20 17.5523 19.5523 18 19 18H5C4.44772 18 4 17.5523 4 17Z\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol